import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import {StylesService} from '../services/styles.service';
import {GlobalConstantsService, onlyKitLevelFields} from '../services/global-constants.service';


@Injectable()
export class KitCreateResolver implements Resolve<any> {

  constructor(
    private stylesService: StylesService,
    private globalConstantsService: GlobalConstantsService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<any> | Promise<any> | any {

    return this.stylesService.fetchAll$().flatMap(
      (styles) => {
        return this.globalConstantsService.getAll().flatMap(
          (globalFields) => {

            return Observable.of({
              styles: styles,
              metaDataFields: onlyKitLevelFields(globalFields)
            });
          }
        );
      }
    );

  }
}





// WEBPACK FOOTER //
// ./src/app/resolvers/kit-create.resolver.ts